import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { apiGet, apiPut } from '../client';
import { qk } from './keys';
import type { PassportDocument, PassportDocumentInput } from '../types';

export function usePassport() {
  return useQuery({
    queryKey: qk.passport,
    queryFn: async () => {
      try {
        return await apiGet<PassportDocument>('/me/passport');
      } catch {
        return null;
      }
    },
  });
}

export function useUpsertPassport() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (body: PassportDocumentInput) => apiPut<PassportDocument>('/me/passport', body),
    onSuccess: (data) => {
      qc.setQueryData(qk.passport, data);
      qc.invalidateQueries({ queryKey: qk.me });
    },
  });
}
